export default __webpack_public_path__ + "static/media/base.519acff9.png";